export default {
  kvText: 'Pesta Belanja Dimulai!\nBersiaplah untuk Penawaran Menarik!',
  countdown: {
    start: 'Waktu hingga Event Dimulai: {time}',
    end: 'Waktu tersisa hingga event berakhir: {time}',
  },
  verify: {
    title: 'Verifikasi Akun',
    placeholder: 'Silahkan Masukan ID Akun Kamu',
    accountId: 'ID Akun',
    accountName: 'Nama Akun',
    login: 'Login',
    confirm: 'Silahkan konfirmasi informasi akun',
    switchAccount: 'Masuk Kembali',
  },
  plaza: 'Pusat Belanja',
  desc: 'Kunjungi halaman Top Up online [{clickHere}]. Setiap Top Up 100 Rainbow Diamonds akan memberimu 1 Voucher Belanja. Gunakan Voucher Belanja untuk membeli hadiah menarik di Pusat Belanja!',
  clickHere: 'Klik di sini',
  eventTime: 'Periode Event: 6 Nov 2026, 00.00–15 Nov 2026, 23.59 (GMT+7)\nPeriode klaim hadiah berakhir pada 22 Nov 2026 pukul 23.59 (GMT+7).',
  remaining: 'Sisa Voucher Belanja: {n}',
  remainingLabel: 'Sisa Voucher Belanja:',
  goods: {
    hotDeals: 'Promo Menarik',
    dailyDeals: 'Promo Hemat',
    viewDaily: 'Daftar Promo Hemat',
    price: '{n} Voucher Belanja',
    purchase: 'Beli',
    remainTimes: 'Sisa Kesempatan Pembelian: {n}',
    notEnoughVoucher: 'Voucher Belanja Tidak Cukup',
    soldOut: 'Habis Terjual',
    max: 'MAX',
    confirm: 'Yakin ingin menggunakan {n} Voucher Belanja untuk membeli {name}?',
    success: 'Pembelian berhasil. Silakan login ke game dan periksa kotak surat dalam game.',
    history: 'Riwayat Pembelian',
    spent: 'Voucher Belanja yang Digunakan',
    details: 'Detail Pembelian',
    time: 'Waktu Pembelian',
    expired: 'Item yang Anda pilih sudah kedaluwarsa. Silakan muat ulang halaman dan pilih kembali.',
    notEnoughDesc: 'Voucher Belanja Anda tidak cukup. Top Up Rainbow Diamonds untuk mendapatkan lebih banyak Voucher Belanja.',
  },
  milestone: {
    allAchieved: 'Anda dapat mengklaim semua hadiah',
    subtitle: 'Gunakan Voucher Belanja dan Raih Deluxe Chest!',
    topUp: 'Top Up Sekarang',
    history: 'Riwayat Hadiah',
    claimAll: 'Klaim Semua',
    nextTip: 'Gunakan {n} Voucher Belanja lagi untuk mengklaim hadiah berikutnya',
    obtained: 'Diperoleh',
    claimable: 'Dapat Diklaim',
    notAchieved: 'Belum Tercapai',
    spend: 'Gunakan {n} Voucher Belanja',
    header: 'Tonggak Pencapaian',
    rewardDetails: 'Detail Hadiah',
    claimTime: 'Waktu Klaim',
    claimSuccess: 'Berhasil Diklaim!',
    claimAllSuccessDesc: 'Semua hadiah yang tersedia berhasil diklaim!\nLihat detailnya di {history}.',
    claimSuccessDesc: 'Item berhasil diklaim! Silakan login ke game untuk mengambil hadiah melalui kotak surat dalam game!',
  },
  common: {
    empty: 'Belum ada catatan',
    confirm: 'Konfirmasi',
    cancel: 'Batal',
  },
  rule: {
    title: 'Peraturan Event',
    content: [
      '1. Selama event berlangsung, lakukan top up Rainbow Diamonds melalui Pusat Top Up Resmi untuk mendapatkan Voucher Belanja. Setiap top up 100 Rainbow Diamonds akan memberikan 1 Voucher Belanja.',
      '2. Gunakan Voucher Belanja di Plaza Belanja untuk menukarkan berbagai item, termasuk Bingkai Avatar eksklusif event – Jago Belanja.\nKamu bisa mendapatkan [Daily Deals] – hadiah bernilai tinggi hanya dengan 1 Voucher Belanja. Hadiah ini akan diperbarui setiap hari pukul 00:00 (GMT+7).',
      '3. Penggunaan Voucher Belanja akan menambah progres belanja. Setelah mencapai milestone yang ditentukan, kamu dapat mengklaim Deluxe Chest yang sesuai.',
      '4. Setelah event berakhir, Voucher Belanja yang belum digunakan akan kedaluwarsa. Harap gunakan voucher tepat waktu. Hadiah milestone yang belum diklaim akan otomatis dikirim melalui surat dalam game.',
      '5. Ikuti event melalui kanal pembayaran pihak ketiga resmi yang telah ditentukan. Kelayakan partisipasi dan hadiah yang terkait dengan transaksi yang dikembalikan dananya, pesanan tidak wajar, atau pelanggaran aturan akan ditangani sesuai ketentuan event.',
      '6. Jika memiliki pertanyaan, silakan hubungi kami melalui tombol Layanan Pelanggan di halaman ini atau melalui kanal Layanan Pelanggan di dalam game.',
    ].join('\n\n'),
  },
  status: {
    notStart: 'Event belum dimulai',
    ended: 'Event telah berakhir',
  },
}
